import { createRegisterCleaner } from '../../watchers/createRegisterCleaner';
import { useBasePurchase } from './useBasePurchase';

export const usePurchaseRegisterCleaner = createRegisterCleaner({
  useStoreHook: useBasePurchase,
  targetPathPrefix: '/purchase-register',
  resetFnName: 'handlerResetBasePurchase',
});
